<template>
    <Head title="Forgot Password">
        <meta name="robots" content="noindex,nofollow">
    </Head>

    <div class="relative lg:fixed h-full shrink-0 justify-center md:px-12 lg:px-0 bg-white">
        <div class="relative z-10 flex flex-1 flex-col h-full bg-white px-4 py-10 shadow-2xl md:flex-none md:px-28 overflow-y-scroll overflow-x-hidden scrollbar-hide">
            <jet-authentication-card class="">
                <div class="flex justify-center items-center">
                    <jet-authentication-card-logo-colored />
                </div>

                <section aria-label="Forgot Password Form">
                    <h1 class="text-lg font-semibold text-gray-900 text-center mt-5">
                        Forgot Password
                    </h1>

                    <div class="mt-8 text-sm text-gray-700">
                        Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.
                    </div>

                    <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                        {{ status }}
                    </div>

                    <jet-validation-errors class="mb-4" />

                    <form @submit.prevent="submit" aria-label="Email Password Reset Form" class="mt-10 grid grid-cols-1 gap-y-6">
                        <div>
                            <jet-label for="email" value="Email" class="mb-3 block text-sm font-medium text-gray-700" />
                            <jet-input id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus />
                        </div>

                        <div class="flex items-center justify-end mt-4">
                            <jet-button custom_class="group inline-flex items-center justify-center rounded-full py-2 px-4 text-sm font-semibold focus:outline-none focus-visible:outline-2 focus-visible:outline-offset-2 bg-blue-600 text-white hover:text-slate-100 hover:bg-black active:bg-blue-800 active:text-blue-100 focus-visible:outline-blue-600 w-full" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                                Email Password Reset Link
                            </jet-button>
                        </div>
                        <div>
                            <Link :href="route('login')" class="text-sm text-gray-900">
                                <font-awesome-icon :icon="faChevronLeft()" class="mr-3"></font-awesome-icon>Back to Login
                            </Link>
                        </div>
                    </form>
                </section>
            </jet-authentication-card>
        </div>
        
    </div>
    <div class="hidden md:flex lg:pl-72 h-screen rentrisk-sidebar-gradient"></div>
</template>

<script>
    import { Head } from '@inertiajs/vue3';
    import JetAuthenticationCard from '@/Jetstream/AuthenticationCard.vue'
    import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo.vue'
    import JetAuthenticationCardLogoColored from '@/Jetstream/AuthenticationCardLogoColored.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetValidationErrors from '@/Jetstream/ValidationErrors.vue'
    import { Link } from '@inertiajs/vue3';
    import moment from "moment";
    import JetNavLink from '@/Jetstream/NavLink.vue'
    import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
    import {faChevronLeft} from "@fortawesome/pro-light-svg-icons";

    export default {
        components: {
            FontAwesomeIcon,
            Head,
            JetAuthenticationCard,
            JetAuthenticationCardLogo,
            JetAuthenticationCardLogoColored,
            JetButton,
            JetInput,
            JetLabel,
            JetValidationErrors,
            Link,
            JetNavLink,
        },

        props: {
            status: String
        },

        data() {
            return {
                form: this.$inertia.form({
                    email: ''
                })
            }
        },

        methods: {
            faChevronLeft() {
                return faChevronLeft
            },
            submit() {
                this.form.post(this.route('password.email'))
            }
        }
    }
</script>
